export default [{
  path: '/business-trips',
  name: 'business_trips',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/businessTrips/index')
}]
